export class Text {
  constructor(difference) {
    this.styleId = 1
    this.width = 168
    this.height = 34
    this.top = 10
    this.left = 10
    this.textType = "title"
    this.innerElement = "cxText"
    this.content = "请输入文本内容"
    this.contentHasLimit = true
    this.contentHasLimitRadio = "行数"
    this.textLimitLines = 1
    this.openBlankPage = true
    this.linkUrl = ""
    this.internalLinkName = ""
    this.linkAddress = "自定义"
    this.accessRulers = []
    this.fontFamily = "sans-serif"
    this.lineHeight = 34
    this.lineHeightType = "px"
    this.fontSize = 24
    this.fontWeight = 600
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(0, 0, 0, 0.8)"
    this.colorArr = {}
    this.textIsThemeColor = false
    this.hoverTextIsThemeColor = false
    this.colorType = "纯色"
    this.startColor = "rgba(0, 0, 0, 0.8)"
    this.endColor = "rgba(0, 0, 0, 0.8)"
    this.colorlinearGradientAngle = 90
    this.bgType = "自定义"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.textAlign = "left"
    this.writingMode = "horizontal-tb"
    this.rotate = 0
    this.textDecoration = "none"
    this.textIndent = 0
    this.textPaddingTypeFlag = 2
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.textOverFlowType = "visible"
    // 透明度
    this.opacity = 100
    // 阴影
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    // 投影
    this.textShadowColor = []
    this.textShadowH = []
    this.textShadowV = []
    this.textShadowBlur = []
    this.background = []
    // 文本的动画要保留，因为有跑马灯效果
    this.animateSets = {
      animateType: 0,
      animateDirection: "无",
      animateDuration: 1.5,
      animateDelay: 0,
      hasDirection: false,
      animateTriggerNumType: "单次触发",
      animateClass: "",
      executionAnimateClass: ""
    }
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.linkLoading = true  //挂了链接可点击打开
    this.emptyDataShowLocal = false //空数据时显示自定义内容
    this.emptyContent = "" //自定义空数据内容
    //外接数据源空数据文本样式
    this.emptyFontFamily = "sans-serif"
    this.emptyFontSize = 24
    this.emptyFontWeight = 400
    this.emptyFontColor = "rgba(0, 0, 0, 0.8)"
    this.isEmptyData = false
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
